import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const RemitterAccountFailed = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const createAccountHandler = () => {
    navigate("/remitter_account_dashboard/create_remitter_account");
  };

  const dashboardHandler = () => {
    navigate("/remitter_account_dashboard");
  };

  const primaryBtn = {
    enabledBgColor: "var(--text-primary)",
    enabledTextColor: "var(--negative-bg)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    imgColor: "var(--negative-bg)",
    hoverOption: "dark",
  };

  const outlineBtn = {
    enabledBgColor: "var(--negative-bg)",
    enabledTextColor: "var(--text-primary)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    outLineColor: "var(--text-primary)",
    hoverOption: "white",
  };

  const buttonRows = [
    [
      {
        ...primaryBtn,
        btnText: "Create account",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createAccountHandler,
      },
      {
        ...outlineBtn,
        btnText: "Go to dashboard",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title="Failed to create remitter account."
      buttonRows={buttonRows}
      hoverOption="white"
    >
      <TabsWeapperSection title="Error details">
        <>
          <InfoCard
            bgColor="var(--negative-card)"
            rows={[
              {
                leftTitle: (() => {
                  if (typeof state === "string") return state;
                  if (state?.error) return state.error;
                })(),
                leftSubTitle: "Error message",
              },
            ]}
          />
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default RemitterAccountFailed;
